export const FETCH_LIST_FILM_SUCCESS =
  "movieManagement/FETCH_LIST_FILM_SUCCESS";
export const FETCH_FILM_INFO_SUCCESS =
  "movieManagement/FETCH_FILM_INFO_SUCCESS";
export const ACT_ADD_FILM_API_SUCCESS =
  "movieManagement/ACT_ADD_FILM_API_SUCCESS";
